import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { pdsCustomElement as customElement } from '../../decorators/pds-custom-element';
import { PdsElement } from '../PdsElement';
import styles from './box-button.scss?inline';
import '@principal/design-system-icons-web/arrow-right';

/**
 * @summary A clickable box that contains a primary action
 *
 * @slot default The content of the box button
 *
 * @fires pds-box-button-click A custom event dispatched on click
 */
@customElement('pds-box-button', {
  category: 'component',
  type: 'component',
  styles,
})
export class PdsBoxButton extends PdsElement {
  /**
   * Style variant
   * - **default** box button has a lighter gradient background
   * - **strong** renders a box button with a darker gradient background
   */
  @property()
  variant: 'default' | 'strong';

  /**
   * The href attribute of the anchor tag that surrounds the box-button
   */
  @property()
  href = '#';

  handleClick() {
    const event = new CustomEvent('pds-box-button-click', {
      bubbles: true,
      composed: true,
      detail: {
        summary: this.textContent,
      },
    });

    this.dispatchEvent(event);
  }

  /**
   * @internal
   */
  get classNames() {
    return {
      [this.variant]: !!this.variant,
    };
  }

  render() {
    return html`<a
      href=${this.href}
      class=${this.getClass()}
      @click=${this.handleClick}
    >
      <div class="pds-c-box-button__body">
        <div class="pds-c-box-button__content">
          <slot>Default Content</slot>
        </div>
        <div class="pds-c-box-button__actions">
          <span class="pds-c-box-button__icon">
            <pds-icon-arrow-right size="lg"></pds-icon-arrow-right>
          </span>
        </div>
      </div>
    </a>`;
  }
}
